/**
 * @file: styles.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { StyleSheet } from 'react-native';

export const useOrderFormStyles = () => {
  const { rpx } = useResponsiveContext();
  return StyleSheet.create({
    formInput: {
      borderWidth: 0,
      paddingLeft: 0,
      paddingRight: rpx(10),
      paddingTop: 0,
      paddingBottom: 0,
      fontSize: rpx(15),
      backgroundColor: 'transparent',
    },
    iconWrapper: {
      width: rpx(40),
      height: rpx(40),
      backgroundColor: '#fff',
      borderWidth: 1,
      borderColor: '#f5f5f5',
      borderRadius: rpx(20),
      marginLeft: rpx(-10),
    },
    section: {
      backgroundColor: '#fff',
      marginTop: rpx(15),
      marginLeft: rpx(15),
      marginRight: rpx(15),
      borderRadius: rpx(8),
    },
    sectionTitle: {
      marginLeft: rpx(30),
      marginRight: rpx(15),
      marginTop: rpx(20),
      marginBottom: rpx(-10),
    },
    sectionTitleText: {
      color: '#888',
      fontFamily: FontFamily.NotoSans.Regular,
      fontSize: rpx(13),
      textShadowColor: '#fff',
      textShadowOffset: { width: 1, height: 1 },
      textShadowRadius: 0,
    },
    row: {
      padding: rpx(15),
    },
    rowSeparator: {
      marginLeft: rpx(20),
      backgroundColor: '#f2f2f2',
    },
    rowTitle: {
      marginLeft: rpx(10),
    },
    rowTitleText: {
      color: '#777',
      fontFamily: FontFamily.NotoSans.Medium,
      fontSize: rpx(14),
    },
    note: {
      marginLeft: rpx(10),
      marginTop: rpx(5),
      fontSize: rpx(12),
      color: '#999',
    },
  });
};
